import React, { createContext, useContext } from 'react';
export var MessageInputContext = createContext(undefined);
export var MessageInputContextProvider = function MessageInputContextProvider(_a) {
  var children = _a.children,
      value = _a.value;
  return React.createElement(MessageInputContext.Provider, {
    value: value
  }, children);
};
/**
 * hook for MessageInput context
 */

export var useMessageInputContext = function useMessageInputContext() {
  var contextValue = useContext(MessageInputContext);

  if (contextValue === undefined) {
    console.warn('Empty MessageInputContext consumed. Make sure you wrap every component that uses MessageInputContext with a MessageInputContextProvider');
  }

  return contextValue;
};